import { AuthProvider } from "../AuthProvider";
import { IdTokenResponse } from "react-aad-msal";

const token = async (): Promise<IdTokenResponse> => {
  return await AuthProvider.getIdToken();
};

export const Get = async (
  url: string,
  cacheFirst: boolean = false,
  returnError: any = false
): Promise<Response> => {
  let headers: Headers | string[][] | Record<string, string> = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${(await token()).idToken.rawIdToken}`,
  };
  if (cacheFirst) {
    headers = { ...headers, "Prioritize-Cache": "true" };
  }

  return fetch(url, {
    headers,
  })
    .then((response) => handleResponse(response, returnError))
    .catch(handleError);
};

export const Post = async (
  url: string,
  payload: string | null
): Promise<Response> => {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${(await token()).idToken.rawIdToken}`,
    },
    body: payload,
  });
};

export const Patch = async (
  url: string,
  payload: string | null
): Promise<Response> => {
  return fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${(await token()).idToken.rawIdToken}`,
    },
    body: payload,
  })
    .then(handleResponse)
    .catch(handleError);
};

export const Delete = async (url: string) => {
  return fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${(await token()).idToken.rawIdToken}`,
    },
  });
};

export function handleResponse(response: Response, returnErr = false): any {
  if (response.ok) {
    return response;
  }
  if(returnErr){
    return response;
  }
  throw new Error("Network response was not ok.");
}

export function handleError(error: any): void {
  throw error;
}
